import { BUILD_ENVIRONMENT_IDENTIFIER } from './build-environment-identifier';

const HOSTNAME_ENVIRONMENT_MAP: Record<string, string> = {
  'dev.tryglamera.com': 'dev',
  'dev.localhost': 'dev',
  'stage.tryglamera.com': 'stage',
  'stage.localhost': 'stage',
  'pro.tryglamera.com': 'live',
  'pro.localhost': 'live',
  'sys.tryglamera.com': 'live',
  'sys.localhost': 'live',
  'app.tryglamera.com': 'live',
  'app.localhost': 'live',
  'prodump.tryglamera.com': 'prodump',
  'prodump.localhost': 'prodump',
  'live.tryglamera.com': 'live',
  'live.localhost': 'live',
};

/** Environments where booking/staging URLs must not be indexed (keep in sync with environment-config blockSearchIndexing). */
export const SEARCH_INDEX_BLOCKED_ENVIRONMENTS = new Set(['dev', 'stage', 'prodump']);

/**
 * Determines the environment key: build config, window.ENVIRONMENT_IDENTIFIER, localStorage, URL ?env=, hostname map, else dev.
 */
export function getEnvironmentIdentifier(): string {
  if (BUILD_ENVIRONMENT_IDENTIFIER) {
    return BUILD_ENVIRONMENT_IDENTIFIER;
  }

  const envVar = (window as Window & { ENVIRONMENT_IDENTIFIER?: string }).ENVIRONMENT_IDENTIFIER;
  if (envVar) {
    return envVar;
  }

  const localStorageEnv = localStorage.getItem('environment_identifier');
  if (localStorageEnv) {
    return localStorageEnv;
  }

  const urlParams = new URLSearchParams(window.location.search);
  const urlEnv = urlParams.get('env');
  if (urlEnv) {
    return urlEnv;
  }

  const hostname = window.location.hostname;

  for (const key in HOSTNAME_ENVIRONMENT_MAP) {
    if (hostname.includes(key)) {
      return HOSTNAME_ENVIRONMENT_MAP[key];
    }
  }

  return 'dev';
}

export function shouldBlockSearchIndexing(identifier: string = getEnvironmentIdentifier()): boolean {
  return SEARCH_INDEX_BLOCKED_ENVIRONMENTS.has(identifier);
}
